<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>
    
    <div class="modal-content">

      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Add a new BOM detail</p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <v-form 
          class="modal-card-body" 
          :valid.sync="valid">

          <div class="field">
            <label class="label">Product Category*</label>
            <v-select
              v-if="categories.length > 0"
              required
              :options="categories"
              item-value="id"
              item-text="category"
              v-model="categoryId"
            />
          </div>

          <div class="field">
            <label class="label">Product*</label>
            <template v-if="categoryId">
              <v-select
                v-if="products.length > 0"
                required
                :options="products"
                item-value="id"
                item-text="name"
                v-model="detail.product_master_id"
              />
              <span v-else class="has-text-grey-light">
                No products in this category
              </span>
            </template>
            <span v-else class="has-text-grey-light">
              Please select a category
            </span>
          </div>

          <div class="columns" v-if="categoryId && category.has_dimensions">
            <div class="column is-one-third">
              <label class="label">L"*</label>
              <v-text-field 
                required
                placeholder="Enter Length"
                v-model="detail.length_in_str">
              </v-text-field>
            </div>
            <div class="column is-one-third">
              <label class="label">W"*</label>
              <v-text-field 
                required
                placeholder="Enter Width"
                v-model="detail.width_in_str">
              </v-text-field>
            </div>
            <div class="column is-one-third">
              <label class="label">T"*</label>
              <v-text-field 
                required
                placeholder="Enter Thickness"
                v-model="detail.thick_in_str">
              </v-text-field>
            </div>
          </div>

          <div class="field">
            <label class="label">Finish Quantity*</label>
            <v-text-field 
              required
              placeholder="Enter Finished Quantity"
              v-model="detail.finished_qty">
            </v-text-field>
          </div>

        </v-form>

        <footer class="modal-card-foot">
          <button 
            :disabled="!valid"
            class="button is-primary" 
            @click.stop="addNewDetail()">
            Save
          </button>
          <button 
            class="button" 
            @click.stop="close(true)">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VForm from '@/components/base/VForm'
import VTextField from '@/components/base/VTextField'
import VSelect from '@/components/base/VSelect'

import { mapState, mapActions } from 'vuex'

export default {
  components: { VForm, VTextField, VSelect },
  props: {
    value: {
      type: Boolean
    },
    bomId: {
      type: [String, Number]
    }
  },
  data() {
    return {
      categoryId: null,
      valid: false,
      detail: {
        bom_id: null,
        product_master_id: null,
        finished_qty: null,
        length_in_str: null,
        width_in_str: null,
        thick_in_str: null
      }
    }
  },
  computed: {
    ...mapState("products", ["categories", "products"]),
    category() {
      return this.categories.filter(d => d.id == this.categoryId)[0];
    }
  },
  watch: {
    categoryId(id) {
      this.getProducts({ product_category_id: id, per_page: 1000 });
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    ...mapActions("products", ["getCategories", "getProducts"]),
    ...mapActions("bom", ["addDetail"]),
    initialize() {
      if (this.categories.length == 0) {
        this.getCategories();
      }
    },
    addNewDetail() {
      this.detail.bom_id = this.bomId;

      this.addDetail(this.detail)
        .then(resp => this.notifySuccess(resp));
    },
    notifySuccess(resp) {
      this.$emit('success', resp);
      this.close(true);
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>


<style scoped>
</style>